// extracted by mini-css-extract-plugin
module.exports = {"selectTask":"TasksTab_selectTask__1xg5M"};